var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"mt-1",attrs:{"block":"","depressed":"","dark":"","disabled":!_vm.Ok || _vm.Ejecutando},on:{"click":_vm.Ejecutar}},[_vm._v("Facturar todo")]),_c('facturacion',{attrs:{"Pedidos":_vm.Pedidos,"Abrir":_vm.AbiertoFacturar},on:{"cerrar":_vm.Actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }